<template>
  <v-app class="app">
    <div
      v-if="!cookiesAccepted"
      :class="!cookiesAccepted ? 'overlay' : ''"
    >
      <div
        v-if="cookieComplyModalDialog"
      >
        <cookie-comply-modal
          @cookieComplyModalClose="cookieComplyModalDialog = false"
          @cookieComplySave="acceptCookies"
        />
      </div>
      <div v-if="!cookiesAccepted">
        <cookie-comply
          @openCookieModal="showCookieComplyModal()"
          @acceptAllCookies="acceptAllCookies"
        />
      </div>
    </div>
    <v-app-bar
      app
      color="#EE730F"
      dark
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.display.smAndDown"
        @click="drawer = !drawer"
      />
      <v-toolbar-title
        v-if="!$vuetify.display.smAndDown"
        flat="true"
        style="width: 100%"
      >
        <a
          href="/"
          class="white--text d-flex justify-center"
          style="text-decoration: none;"
        >
          <v-img
            src="@/assets/banner.png"
            style="min-width: 100px; min-height: 50px; max-width: 150px;max-height: 75px"
          />
        </a>
      </v-toolbar-title>
      <v-tabs v-if="!$vuetify.display.smAndDown">
        <v-tab   
          @click="$router.push('/')"
        >
          {{ $t('navigation.home') }}
        </v-tab>
        <v-tab @click="$router.push('/shop')">
          {{ $t('navigation.shop') }}
        </v-tab>
        <v-tab 
          v-if="adminAccessToken"
          @click="$router.push('/controlpanel')"
        >
          {{ $t('navigation.admin') }}
        </v-tab>
      </v-tabs>
      <v-spacer />
      <v-autocomplete
        v-if="$route.path !== '/shop'"
        v-model="selectedProduct"
        :items="searchableProducts"
        :loading="isLoading"
        :search-input="search"
        cache-items
        :class="['mx-4', { 'flex-grow-1': $vuetify.display.smAndDown }]"
        flat
        hide-no-data
        hide-details
        :label="$t('navigation.searchPlaceholder')"
        :no-data-text="$t('navigation.noDataText')"
        :loading-text="$t('navigation.loadingText')"
        solo-inverted
        item-title="name"
        item-value="inventoryNumber"
        @update:search-input="search = $event"
        @update:model-value="handleProductSelect"
      >
        <template #item="{ props, item }">
          <v-list-item
            v-bind="props"
            :title="item.raw.name"
            :subtitle="item.raw.type"
          >
            <template #prepend>
              <v-avatar>
                <v-img
                  :src="getProductImage(item.raw)"
                  :alt="item.raw.name"
                />
              </v-avatar>
            </template>
          </v-list-item>
        </template>
      </v-autocomplete>
      <div v-if="false">
        <v-btn
          variant="flat"
          append-icon="mdi-cart"
          color="#EE730F"
          href="/shop"
          :rounded="true"
        >
          {{ $t('shopMenuDropDown') }}
        </v-btn>
      </div>
      <v-tooltip :text="$t('selectLanguage')">
        <template #activator="{ props }">
          <v-btn
            style="padding-bottom: 11px;"
            icon
            v-bind="props"
            @click="showLanguageSelect = true "
          >
            <country-flag
              :country="$i18n.locale"
              :shadow="true"
              size="normal"
            /> 
            <v-menu activator="parent">
              <v-list>
                <v-list-item
                  v-for="(item, index) in languages"
                  :key="index"
                  :value="index"
                  @click="$i18n.locale = item.flag"
                >
                  <v-row>
                    <v-col>
                      <country-flag
                        :style="!important"
                        rounded="true"
                        :country="item.flag"
                        :shadow="true"
                        size="big"
                      /> 
                    </v-col>
                    <v-col>
                      <v-list-item-title style="margin-top: 10%;">
                        {{ item.value }}
                      </v-list-item-title>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </template>
      </v-tooltip>
      <v-dialog
        v-model="showLoginDialog"
        :fullscreen="$vuetify.display.smAndDown"
        :width="$vuetify.display.smAndDown ? '100%' : '500'"
        :transition="$vuetify.display.smAndDown ? 'dialog-bottom-transition' : 'dialog'"
      >
        <v-card
          class="login-dialog-card"
          :flat="$vuetify.display.smAndDown"
        >
          <v-toolbar
            v-if="$vuetify.display.smAndDown"
            color="#EE730F"
            class="px-4"
          >
            <v-btn
              icon
              @click="showLoginDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('login') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-title
            v-else
            class="text-h5"
          >
            {{ $t('login') }}
          </v-card-title>
          <LoginPopup @close-dialog="showLoginDialog = false" />
        </v-card>
      </v-dialog>
      <v-tooltip :text="$t('userMenu')">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            @click="handleAccountClick()"
          >
            <v-menu
              v-if="userAccessToken !== null"
              activator="parent"
              @click.stop.prevent
            >
              <!-- v-card for the dropdown content -->
              <v-card
                height="100%"
                width="100%"
                min-width="200"
                style="display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative;"
              >
                <!-- Fixed header -->
                <v-card-title style="position: sticky; top: 0; z-index: 1;">
                  {{ $t('userMenu') }}
                </v-card-title>
        
                <!-- Scrollable content area -->
                <v-container
                  style="background: white; overflow-y: auto; flex: display; width: 100%;"
                  fluid="true"
                >
                  <v-list width="100%">
                    <v-list-item @click="goToManageAccount()">
                      <v-btn style="margin-top: 5%; width:100%;background-color:#EE730F;color:whitesmoke;">
                        {{ $t('manageAccount') }}
                      </v-btn>
                    </v-list-item>
                    <v-list-item @click="logOutUser()">
                      <v-btn style="margin-top: 10%; width:100%;background-color:#EE730F;color:whitesmoke">
                        {{ $t('logout') }}
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-container>
              </v-card>
            </v-menu>
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip :text="$t('cartMenu')">
        <template #activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            v-on="on"
          >
            <v-menu
              v-model="cartMenu"
              activator="parent"
              :transition="$vuetify.display.smAndDown ? 'dialog-bottom-transition' : 'scale-transition'"
              :fullscreen="$vuetify.display.smAndDown"
              :width="$vuetify.display.smAndDown ? '100%' : '400'"
              @click.stop.prevent
            >
              <!-- v-card for the dropdown content -->
              <v-card
                height="100%"
                width="100%"
                :min-width="$vuetify.display.smAndDown ? '100%' : '400'"
                style="display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative;"
              >
                <!-- Fixed header -->
                <v-toolbar
                  v-if="$vuetify.display.smAndDown"
                  color="#EE730F"
                  class="px-4"
                  elevation="2"
                >
                  <v-btn
                    icon
                    color="white"
                    @click="cartMenu = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title class="text-white">
                    {{ $store.state.cartContent.length === 0 ? $t('cartIsEmpty') : $t('cartContent') }}
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-title
                  v-else
                  style="position: sticky; top: 0; z-index: 1;"
                >
                  {{ $store.state.cartContent.length === 0 ? $t('cartIsEmpty') : $t('cartContent') }}
                </v-card-title>
                <v-icon 
                  v-if="$store.state.cartContent.length === 0"
                  size="64"
                  class="mt-8"
                >
                  mdi-cart
                </v-icon>
      
                <!-- Scrollable content area -->
                <v-container
                  style="background: white; overflow-y: auto; flex: 1; width: 100%;"
                  fluid="true"
                  class="pa-4"
                >
                  <CartListCard />
                </v-container>
      
                <!-- Footer with total price and buttons -->
                <v-container
                  fluid="true"
                  style="background: white; bottom: 0; position: sticky; z-index: 1; width: 100%;"
                  class="pa-4"
                  @click.stop.prevent
                >
                  <v-row
                    align="center"
                    class="flex-column"
                  >
                    <v-divider
                      :color="'#033'"
                      :thickness="2"
                      class="mb-4"
                    />
            
                    <div class="text-h6 mb-4">
                      <b>{{ $t('cartPriceTotal') }}: {{ totalPrice() }} Ft </b>
                    </div>
                    <v-btn
                      color="#6DA34D"
                      :disabled="($store.state.cartContent.length === 0 || (cartContainsRentalItems && (startDate === null || endDate === null))) || cartContainsPeriodDisabledProducts"
                      class="flexButton mb-2"
                      size="large"
                      @click="goToSummaryView(); cartMenu = false"
                    >
                      {{ $t('checkoutCart') }}
                    </v-btn>
                    <v-btn
                      class="flexButton"
                      :disabled="$store.state.cartContent.length === 0"
                      :color="$store.state.cartContent.length !== 0 ? 'red' : 'grey'"
                      size="large"
                      @click="emptyCart"
                    >
                      {{ $t('emptyCart') }}
                    </v-btn>
                  </v-row>
                </v-container>
              </v-card>
            </v-menu>
      
            <!-- Badge for cart item count -->
            <v-badge
              :content="$store.state.cartContent.length"
              :value="$store.state.cartContent.length"
              color="#6DA34D"
              overlap
            >
              <v-icon>mdi-cart</v-icon>
            </v-badge>
          </v-btn>
        </template>
      </v-tooltip>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer
      v-if="$vuetify.display.smAndDown"
      v-model="drawer"
      temporary
      location="left"
    >
      <v-list>
        <v-list-item
          @click="$router.push('/'); drawer = false"
        >
          <v-list-item-title>{{ $t('navigation.home') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="$router.push('/shop'); drawer = false"
        >
          <v-list-item-title>{{ $t('navigation.shop') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="adminAccessToken"
          @click="$router.push('/controlpanel'); drawer = false"
        >
          <v-list-item-title>{{ $t('navigation.admin') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main :class="{ 'home-route': !isHomeRoute }" style="width: 100%; max-width: 100%; margin-right: 0vw;">
      <router-view :class="{ 'home-route': !isHomeRoute }" style="width: 100%; max-width: 100%; margin-right: 0vw;" />
    </v-main>
    <!-- Footer -->
    <footer class="app-footer">
      <v-container>
        <v-row>
          <!-- Contact Info -->
          <v-col
            cols="12"
            md="4"
            class="footer-section"
          >
            <h3 class="footer-title">
              {{ $t('footer.contactUs') }}
            </h3>
            <div class="contact-info">
              <div class="contact-item">
                <v-icon>mdi-phone</v-icon>
                <a href="tel:+36 30 349 9493">+36 30 349 9493</a>
              </div>
              <div class="contact-item">
                <v-icon>mdi-email</v-icon>
                <a href="mailto:limmekrent@gmail.com">limmekrent@gmail.com</a>
              </div>
              <div class="contact-item">
                <v-icon>mdi-map-marker</v-icon>
                <span>2030 Érd, Tóni csapás 5.</span>
              </div>
            </div>
            <!-- Google Maps Embed -->
            <div class="map-container">
              <iframe
                src="https://www.google.com/maps?q=2030+%C3%89rd%2C+T%C3%B3ni+csap%C3%A1s+5&output=embed"
                width="100%"
                height="200"
                style="border:0; border-radius: 8px; margin-top: 16px;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="LimmekRent Location"
              />
            </div>
          </v-col>

          <!-- Business Hours -->
          <v-col
            cols="12"
            md="4"
            class="footer-section"
          >
            <h3 class="footer-title">
              {{ $t('footer.businessHours') }}
            </h3>
            <div class="business-hours">
              <div class="hours-item">
                <span class="weekday">{{ $t('footer.weekdays.monday') }}</span>
                <span class="hours">8-17</span>
              </div>
              <div class="hours-item">
                <span class="weekday">{{ $t('footer.weekdays.tuesday') }}</span>
                <span class="hours">8-16</span>
              </div>
              <div class="hours-item">
                <span class="weekday">{{ $t('footer.weekdays.wednesday') }}</span>
                <span class="hours">8-16:30</span>
              </div>
              <div class="hours-item">
                <span class="weekday">{{ $t('footer.weekdays.thursday') }}</span>
                <span class="hours">8-16</span>
              </div>
              <div class="hours-item">
                <span class="weekday">{{ $t('footer.weekdays.friday') }}</span>
                <span class="hours">8-17</span>
              </div>
            </div>
          </v-col>

          <!-- Social Links -->
          <v-col
            cols="12"
            md="4"
            class="footer-section"
          >
            <h3 class="footer-title">
              {{ $t('footer.followUs') }}
            </h3>
            <div class="social-links">
              <div class="social-item">
                <v-icon>mdi-facebook</v-icon>
                <a href="https://www.facebook.com/profile.php?id=61563373018727" target="_blank" rel="noopener">Facebook</a>
              </div>
              <div class="social-item">
                <v-icon>mdi-twitter</v-icon>
                <a href="https://twitter.com/example">Twitter</a>
              </div>
              <div class="social-item">
                <v-icon>mdi-linkedin</v-icon>
                <a href="https://linkedin.com/company/example">LinkedIn</a>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Divider -->
        <v-divider
          color="white"
          class="my-4"
        />

        <!-- Legal Links -->
        <v-row>
          <v-col cols="12">
            <div class="legal-links">
              <a
                href="/berlesi_szerzodes.pdf"
                target="_blank"
                class="legal-link"
              >
                <v-icon>mdi-file-document</v-icon>
                {{ $t('footer.rentalContract') }}
              </a>
              <a
                href="/aszf.pdf"
                target="_blank"
                class="legal-link"
              >
                <v-icon>mdi-file-document</v-icon>
                {{ $t('footer.termsOfService') }}
              </a>
              <router-link
                to="/impresszum"
                class="legal-link"
              >
                <v-icon>mdi-file-document</v-icon>
                {{ $t('footer.impresszum') }}
              </router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </footer>
    <vue3-snackbar
      bottom
      right
      :duration="4000"
    />
  </v-app>
</template>

<script>
import '@formkit/themes/genesis';
import productService from '@/services/productService';
import CountryFlag from 'vue-country-flag-next';
import { Vue3Snackbar } from 'vue3-snackbar';
import LoginPopup from '@/components/LoginPopup.vue';
import { decodeToken } from '@/services/tokenService';
import CartListCard from './components/CartListCard.vue';
import userService from './services/userService';
import CookieComplyModal from './components/cookiecomply/CookieComplyModal.vue';
import CookieComply from './components/cookiecomply/CookieComply.vue';
import cookieService from '@/services/cookieService';
import { defaultModifiers, longTermMultiplier } from '@/config/pricemodifiers';
import config from '@/config/config';

export default { 
  name: 'App',
  components:{
    CountryFlag,
    Vue3Snackbar,
    LoginPopup,
    CookieComply,
    CookieComplyModal,
    CartListCard
  },
  data: () => ({
    drawer: false,
    selectedCountry: 'en',
    cookiesAccepted: false,
    showLoginDialog: false,
    cookieComplyModalDialog: false,
    cartMenu: false,
    selectedProduct: null,
    search: null,
    isLoading: false,
    languages: [
      {
        flag:'gb',
        value: 'English'
      },
      {
        flag:'hu',
        value: 'Magyar'
      },
      {
        flag:'de',
        value: 'Deutsch'
      },
      {
        flag:'es',
        value: 'Español'
      }
    ]
  }),
  computed: {
    startDate: {
      get() {
        return this.$store.getters.getStartDate;
      },
      set(value) {
        this.$store.commit('SET_ORDERDATE_START', value);
      }
    },
    endDate: {
      get() {
        return this.$store.getters.getEndDate;
      },
      set(value) {
        this.$store.commit('SET_ORDERDATE_END', value);
      }
    },
    userAccessToken: {
      get() {
        return this.$store.getters.getUserAccesstoken;
      },
      set(value) {
        this.$store.commit('SET_USER_TOKEN', value);
      }
    },
    adminAccessToken: {
      get() {
        const token = this.$store.getters.getAdminAccessToken;
        return token;
      }
    },
    daysCount() {
      if (this.startDate && this.endDate) {
        return (new Date(this.endDate).getTime() - new Date(this.startDate).getTime()) / (1000 * 3600 * 24);
      }
      return 1;
    },
    cartContainsPeriodDisabledProducts(){
      if (!config.featureFlags.enforceQuantityAvailability) return false;
      return this.$store.state.cartContent.some(product => product.product.availableQuantityForPeriod === 0);
    },
    cartContainsRentalItems() {
      return this.$store.state.cartContent.some(product => !product.product.purchasable);
    },
    searchableProducts() {
      return this.$store.state.availableProducts || [];
    },
    isHomeRoute() {
      return this.$route.name === 'ShopVIew' || this.$route.path === '/shop';
    }
  },
  async created() {
    this.$i18n.locale = this.setUserLocaleOnLoad();
    
    this.selectedCountry  = this.$store.state.locale;
    this.getCategories();
  },
  async mounted() {
    this.cookiesAccepted = cookieService.isRequiredAccepted();

    if (this.cookiesAccepted) {
      cookieService.initializeAnalytics();
      cookieService.initializeThirdPartyServices();
    }
    
    // Initialize Google Analytics if cookies are accepted
    if (this.cookiesAccepted) {
      this.initializeGoogleAnalytics();
    }
    
    /*const response = await productService.getProductsList();
    this.$store.commit('SET_PRODUCTLIST',response.data);*/
    await this.getProductsList();
    if(this.$store.getters.getUserAccesstoken){
      let currentTokenDecoded = decodeToken(this.$store.getters.getUserAccesstoken);
      if(this.isTokenExpired(currentTokenDecoded.exp)){
        const newToken = await userService.makeRequestWithToken(this.$store.getters.getUserAccesstoken);
        this.$store.commit('SET_USER_TOKEN',{userAccessToken:newToken.data.token,snackBarType:'success',snackBarText: 'SUCCESSFUL_DATA_UPDATE'});
      }
    }
    this.$store.state.productList.forEach(product => {
      if (product.quantity === undefined) {
        product.quantity = 1;
      } else if (product.quantity === 0) {
        // Keep quantity as 0 if explicitly set
      }
    });
  },
  methods: {
    goToSummaryView() {
      this.$router.push('/summary');
    },
    acceptAllCookies() {
      cookieService.acceptAllCookies();
      this.cookiesAccepted = true;
      cookieService.initializeAnalytics();
      cookieService.initializeThirdPartyServices();
      this.initializeGoogleAnalytics();
    },
    acceptCookies(data) {
      cookieService.acceptCookies(data);
      this.cookiesAccepted = true;
      cookieService.initializeAnalytics();
      cookieService.initializeThirdPartyServices();
      this.initializeGoogleAnalytics();
    },
    showCookieComplyModal() {
      this.cookieComplyModalDialog = true;
    },
    handleAccountClick() {
      if (this.$store.getters.getUserAccesstoken === null) {
        this.showLoginDialog = true;
      }
    },
    goToManageAccount(){
      if (this.$store.getters.getUserAccesstoken !== null) {
        this.$router.push('/accountmanagement');
      }
    },
    isTokenExpired(timestampStr) {
      const timestamp = parseInt(timestampStr, 10);
      const date = new Date(timestamp * 1000);
      const now = new Date();
      return now > date;
    },
    logOutUser(){
      this.$store.commit('LOGOUT_USER',{userAccessToken:null,snackBarType:'success',snackBarText: this.$t('successfulLogout')});
      this.showLoginDialog = false;
      this.$nextTick(() => {
        if (this.$router.currentRoute.value.path === '/accountmanagement') {
          this.$router.push('/');
        }
        this.$snackbar.add({
          type: 'success',
          text: this.$t('successfulLogout')
        });  
      });
    },
    totalPrice() {
      let total = 0;
      this.$store.state.cartContent.forEach(cartElement => {
        var priceStripped = Number(cartElement.product.price);
        if(this.isDiscountActive(cartElement)){
          priceStripped = priceStripped * (1 - cartElement.product.discount.percentage / 100);
        }
        total += cartElement.product.purchasable ? (cartElement.amount * priceStripped * defaultModifiers.VAT_RATE) : (cartElement.amount * priceStripped * this.daysCount * longTermMultiplier(this.daysCount) * defaultModifiers.VAT_RATE) +(cartElement.amount * cartElement.product.deposit);
      });
      return Math.ceil(total);
    },
    isDiscountActive(cartElement) {
      if (!cartElement.product.discount) return false;
      const today = new Date();
      const endDate = new Date(cartElement.product.discount.endDate);
      return today <= endDate;
    },
    emptyCart(){
      this.$store.commit('EMPTY_CART',{snackBarText:this.$t('cartEmptied')});
    },
    async getCategories(){
      const response = await productService.getProductsList();
      let categoryList = [];
      this.$store.commit('SET_AVAILABLE_PRODUCTS',response.data);

      response.data.forEach(responseObject => {
        if (!categoryList.includes(responseObject.type)) {
          categoryList.push(responseObject.type);
        }
      });
    },
    setUserLocaleOnLoad(){
      if (this.$store.getters.getUserAccesstoken !== null){
        let decodedToken = decodeToken(this.$store.getters.getUserAccesstoken);
        this.$i18n.locale = decodedToken.userData.preferredLanguage;
        if (decodedToken.userData.preferredLanguage === 'en'){
          this.$i18n.locale = 'gb';
          return 'gb';
        }
        return decodedToken.userData.preferredLanguage;
      }
      const availibleLocales = this.$i18n.availableLocales;
      const usersLanguage = window.navigator.language;
      var localReturnValue = '';
      if (usersLanguage === 'en-US' || usersLanguage === 'en'){
        return 'gb';
      }
      availibleLocales.forEach(locale => {
        if(usersLanguage.includes(locale)) {
          localReturnValue = locale;
        }
      });
      if(localReturnValue !== ''){
        return localReturnValue;
      } else {
        return 'gb';
      }
    },
    async getProductsList() {
      try {
        const response = await productService.getProductsList();
        this.$store.commit('SET_PRODUCTLIST', response.data);
        // Update cart elements if cart is not empty
        if (this.$store.state.cartContent.length > 0) {
          this.$store.state.cartContent.forEach((cartItem, index) => {
            const updatedProduct = response.data.find(product => product.serialNumber === cartItem.product.serialNumber);
            if (updatedProduct) {
              this.$store.commit('UPDATE_CART_ELEMENT', {
                index: index,
                price: updatedProduct.price,
                deposit: updatedProduct.deposit,
                upsaleProducts: updatedProduct.upsaleProducts
              });
            }
          });
        }
      } catch (error) {
        this.$snackbar.add({
          type: 'error',
          text: this.$t('backendResponses.ERROR_DATA_FETCH')
        });
      }
    },
    downloadPDF(filename) {
      window.open(filename, '_blank');
    },
    handleProductSelect(product) {
      if (product) {
        this.$router.push({
          path: '/shop',
          query: { viewKey: product }
        });
      }
    },
    getProductImage(product) {
      if (!product?.inventoryNumber) return require('@/assets/no_image.jpg');
      return `${config.backendUrl}/uploads/${product.inventoryNumber}.jpg`;
    },
    initializeGoogleAnalytics() {
      // Load Google Analytics script dynamically
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-HGY2DYNY97';
      document.head.appendChild(script1);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      
      gtag('js', new Date());
      gtag('config', 'G-HGY2DYNY97');
    }
  }
};
</script>
<style>
@font-face {
  font-family: 'Helvetica LT 73 Bold Extended';
  src: url('@/assets/Helvetica LT 73 Bold Extended.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Source Sans Variable';
  src: url('@/assets/SourceSansVariable-Italic.ttf') format('truetype-variations');
  font-weight: 200 900;
  font-style: italic;
  font-display: swap;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Helvetica LT 73 Bold Extended', sans-serif;
}

.flexButton {
  width: 100%;
}
.app {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background: url('@/assets/backgroundpattern.png') repeat;
  filter: blur(3px);
  transform: scale(4) rotate(45deg);
  transform-origin: center;
  z-index: -1;
  pointer-events: none;
  opacity: 1.1; /* Further reduce opacity */
}

.v-main {
  flex: 1;
}

.app-footer {
  width: 100%;
  background-color: #EE730F;
  padding: 30px 0;
  margin-top: auto;
  color: white;
}

.app-footer p {
  font-weight: bold;
  color: white;
}

.contact-icons,
.social-icons {
  display: flex;
  flex-direction: column;
}

.contact-icons a,
.social-icons a {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
}

.contact-icons a:hover,
.social-icons a:hover {
  color: #19273D;
}

.contact-icons v-icon,
.social-icons v-icon {
  font-size: 24px;
  margin-right: 10px;
  color: white;
}
.flexButton {
  width: 100%;
}
.app {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background: url('@/assets/backgroundpattern.png') repeat;
  filter: blur(3px);
  transform: scale(4) rotate(45deg);
  transform-origin: center;
  z-index: -1;
  pointer-events: none;
}

.v-main {
  flex: 1;
}

.app-footer {
  width: 100%;
  background-color: #EE730F;
  padding: 30px 0;
  margin-top: auto;
  color: white;
}

.app-footer p {
  font-weight: bold;
  margin-bottom: 10px;
  color: white;
}

.footer-section {
  margin-bottom: 24px;
}

.footer-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: white;
}

.footer-section:nth-child(2) .footer-title {
  text-align: center;
}

.footer-section:nth-child(3) .footer-title {
  text-align: right;
}

.contact-info,
.social-links,
.business-hours {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item,
.social-item,
.hours-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.contact-item a,
.social-item a {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
  font-size: 1rem;
}

.contact-item a:hover,
.social-item a:hover {
  color: #19273D;
}

.contact-item .v-icon,
.social-item .v-icon {
  font-size: 20px;
  color: white;
  min-width: 24px;
}

.hours-item {
  justify-content: center;
  padding: 8px 0;
}

.hours-item .weekday {
  color: white;
  font-size: 1rem;
  font-weight: 500;
}

.hours-item .hours {
  color: white;
  font-size: 1rem;
  font-weight: 400;
}

.social-links {
  align-items: flex-end;
}

.social-item {
  justify-content: flex-end;
}

.legal-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.legal-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: white;
  transition: all 0.3s ease;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 300px;
  justify-content: center;
}

.legal-link:hover {
  color: #19273D;
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.legal-link .v-icon {
  font-size: 20px;
}

@media (min-width: 960px) {
  .legal-links {
    flex-direction: row;
    justify-content: center;
  }

  .footer-section {
    margin-bottom: 0;
  }
}

@media (max-width: 600px) {
  .app-footer {
    padding: 20px 0;
  }

  .footer-title {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  .contact-item,
  .social-item {
    gap: 8px;
    padding: 6px 0;
  }

  .contact-item a,
  .social-item a {
    font-size: 0.9rem;
  }

  .legal-link {
    padding: 10px 16px;
    font-size: 0.9rem;
  }

  .contact-item .v-icon,
  .social-item .v-icon,
  .legal-link .v-icon {
    font-size: 18px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.cookie-popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.disabled-content {
  pointer-events: none;
  opacity: 0.5;
}

.login-dialog-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@media (max-width: 600px) {
  .v-dialog {
    margin: 0 !important;
    height: 100% !important;
  }

  .v-card {
    border-radius: 0 !important;
  }

  .v-toolbar .v-btn {
    background-color: transparent !important;
  }
}

.mobile-nav .action-btn {
  min-width: 64px !important;
  height: 64px !important;
  margin: 0 8px;
}

.mobile-nav .nav-icon {
  margin-right: 12px;
  min-width: 48px !important;
  height: 48px !important;
}

@media (min-width: 600px) and (max-width: 960px) {
  .mobile-nav .action-btn {
    min-width: 72px !important;
    height: 72px !important;
    margin: 0 12px;
  }

  .mobile-nav .nav-icon {
    margin-right: 16px;
    min-width: 56px !important;
    height: 56px !important;
  }
}

.cart-action-btn {
  font-size: 1.1rem !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-weight: 500;
  padding: 0 24px !important;
}

@media (max-width: 600px) {
  .cart-action-btn {
    font-size: 1rem !important;
    height: 48px !important;
    min-width: 180px !important;
    padding: 0 16px !important;
  }
}

@media (max-width: 600px) {
  .contact-item,
  .social-item,
  .hours-item {
    gap: 8px;
    padding: 6px 0;
  }

  .contact-item a,
  .social-item a {
    font-size: 0.9rem;
  }

  .hours-item .weekday,
  .hours-item .hours {
    font-size: 0.9rem;
  }
}

.legal-links {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.legal-links a {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
}

.legal-links a:hover {
  color: #19273D;
}

.legal-links .v-icon {
  margin-right: 0.5rem;
}

.map-container {
  margin-top: 16px;
}

.map-container iframe {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.map-container iframe:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Default styling for all routes (80% width) */
.v-main {
  width: 70% !important;
  max-width: 70% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  margin-top: 64px !important; /* Account for app bar height */
  position: relative;
  z-index: 2;
}

.v-main .v-container {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Home route specific styling (100% width) */
.home-route {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  margin-top: 64px !important; /* Account for app bar height */
  padding: 0 !important;
  position: relative;
  z-index: 2;
}

.home-route .v-container {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Fix app bar z-index */
.v-app-bar {
  position: fixed !important;
  top: 0 !important;
  z-index: 1000 !important;
  background-color: #EE730F !important;
}

/* Fix footer positioning and z-index */
.app-footer {
  width: 100%;
  background-color: #EE730F;
  padding: 30px 0;
  margin-top: auto;
  color: white;
}

/* Add white background to router-view content */
.v-main .router-view {
  background: white;
  min-height: 100%;
}




@media (max-width: 960px) {
  .map-container iframe {
    height: 180px;
  }
}

@media (max-width: 600px) {
  .map-container iframe {
    height: 160px;
  }

  /* The 70%-width reading column makes sense on desktop but wastes a third
     of the screen on phones - go full width below the mobile breakpoint. */
  .v-main {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    margin-top: 64px !important;
  }
}
</style>
